export default function llms(state = [], action) {
    switch (action.type) {
      case 'ADD_CURRENT':
        return {
          ...state,
          llm: action.llm,
        }
      default:
        return state;
    }
}